module.exports = __webpack_public_path__ + "static/media/Nissan@2x.c78b35db.png";